import { Poi } from "../../../constants/action-constants/map-view/poi/PoiActionConstants";
import {
  setDatalistStatus,
  setDatalistSelected,
  formatRawData,
  setDatalistAdded,
} from "../../util/mapViewUtil";

//initial state
const initialState = {
  originalData: {},
  dataList: [],
  getPoiLoading: false,
  getPoiError: "",
  brandLabelToId: {},
  brandToSectorMap: {},
  sectorToBrandMap: {},
  brandIdToLabel: {},
  sectorLabelToId: {},
  poiTypeIdToSectorId: {},
  atlasSectorIdToLabel: {},
  cityId: "",
};

function filterNonEmptyKeys(rawData = {}) {
  const result = {};

  for (const [key, value] of Object.entries(rawData)) {
    if (typeof value === "object" && value !== null) {
      const filteredChild = {};
      for (const [childKey, childVal] of Object.entries(value)) {
        if (
          typeof childVal === "object" &&
          childVal !== null &&
          Object.keys(childVal).length > 0
        ) {
          filteredChild[childKey] = childVal;
        }
      }

      if (Object.keys(filteredChild).length > 0) {
        result[key] = filteredChild;
      }
    }
  }

  // adding type as key in each poiType Object
  const updatedObj = {};
  for (const key in result) {
    updatedObj[key] = { ...result[key], type: key };
  }

  return updatedObj;
}

function constructDataList(data) {
  const { poiTypeTrees, brandsByPoiType } = data || {};

  const brandLabelToId = {};
  const brandIdToLabel = {};
  const sectorIdToLabel = {};
  const sectorLabelToId = {};
  const brandToSectorMap = {};
  const sectorToBrandMap = {};
  const poiTypeIdToSectorId = {};
  const atlasSectorIdToLabel = {}; // 3.5 sectors

  const rawData = poiTypeTrees.reduce((acc, sector) => {
    const sectorChildren = sector.children || [];
    const isSectorHaveChildren = sectorChildren.length > 0;

    // mapping sectorIdToLabel
    atlasSectorIdToLabel[sector.id] = sector.name;

    // If children exists then we mark it with a type.
    if (isSectorHaveChildren) {
      const typeData = sectorChildren.reduce((poiTypeAcc, poiType) => {
        // mapping SectorId to its label..
        sectorIdToLabel[poiType.id] = poiType.name;

        // mapping SectorId to brandIds;
        sectorToBrandMap[poiType.id] = [];

        // poiTypeId to sectorId
        poiTypeIdToSectorId[poiType.id] = poiType.sectorId;

        // mapping SectorLabel to its id..
        sectorLabelToId[poiType.name] = poiType.id;

        const brandEntries = brandsByPoiType[poiType.id] || [];
        const brandData = brandEntries.reduce((brandAcc, brand) => {
          brandAcc[brand.name] = {};

          // mapping BrandName to its brandId..
          brandLabelToId[brand.name] = brand.id;

          // mapping BrandId to its label
          brandIdToLabel[brand.id] = brand.name;

          // mapping BrandId to its SectorId
          brandToSectorMap[brand.id] = poiType.id;

          // mapping SectorId to brandIds;
          sectorToBrandMap[poiType.id].push(brand.id);
          return brandAcc;
        }, {});
        poiTypeAcc[poiType.name] = brandData;
        return poiTypeAcc;
      }, {});

      typeData.type = sector.name;
      acc[sector.name] = typeData;
      return acc;
    }

    return acc;
  }, {});

  // removing sectors & poiTypes which doesn't have Brand/POI mapping
  const filteredRawData = filterNonEmptyKeys(rawData);

  return {
    // rawData, // old logic for no hiding
    rawData: filteredRawData, // new code for hiding
    brandLabelToId,
    brandToSectorMap,
    brandIdToLabel,
    sectorIdToLabel,
    sectorLabelToId,
    sectorToBrandMap,
    poiTypeIdToSectorId,
    atlasSectorIdToLabel,
  };
}

const poiReducer = (state = initialState, action) => {
  switch (action.type) {
    case Poi.GET_POI:
      return {
        ...state,
        getPoiLoading: true,
        cityId: action.payload.cityId,
      };

    case Poi.GET_POI_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const {
        rawData,
        brandLabelToId,
        brandToSectorMap,
        brandIdToLabel,
        sectorIdToLabel,
        sectorLabelToId,
        sectorToBrandMap,
        poiTypeIdToSectorId,
        atlasSectorIdToLabel,
      } = constructDataList(action.payload);
      return {
        ...state,
        getPoiLoading: false,
        originalData: action.payload,
        dataList: formatRawData(rawData),
        brandLabelToId,
        brandToSectorMap,
        brandIdToLabel,
        sectorIdToLabel,
        sectorLabelToId,
        sectorToBrandMap,
        poiTypeIdToSectorId,
        atlasSectorIdToLabel,
      };

    case Poi.GET_POI_FAILURE:
      return {
        ...state,
        getPoiLoading: false,
        getPoiError: action.payload,
      };

    case Poi.SET_CHECKLIST_SELECTED: {
      const { path, label } = action.payload;
      const dataList = setDatalistSelected(state.dataList, path, label);
      return {
        ...state,
        dataList,
      };
    }
    case Poi.SET_CHECKBOX_STATUS: {
      const { path, label, status } = action.payload;
      const dataList = setDatalistStatus(state.dataList, path, label, status);
      return {
        ...state,
        dataList,
      };
    }

    case Poi.RESET:
      return {
        ...state,
        dataList: [],
      };

    case Poi.SET_POI_STATUS: {
      const { label, status } = action.payload;
      const dataList = setDatalistAdded(
        state.dataList,
        { label: label },
        status
      );
      return {
        ...state,
        dataList,
      };
    }

    default:
      return state;
  }
};

export default poiReducer;
